/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiBatch,
    InternalApiBatchFromJSON,
    InternalApiBatchToJSON,
    InternalApiBatchPage,
    InternalApiBatchPageFromJSON,
    InternalApiBatchPageToJSON,
    InternalApiDataUploadStatusHistoryRecord,
    InternalApiDataUploadStatusHistoryRecordFromJSON,
    InternalApiDataUploadStatusHistoryRecordToJSON,
} from '../models';

export interface FindBatchesRequest {
    page: number;
    size: number;
}

export interface FindStatusHistoryRequest {
    uploadId: number;
}

export interface UploadBatchRequest {
    type: UploadBatchTypeEnum;
    file: Blob;
    delimiter?: UploadBatchDelimiterEnum;
}

/**
 * 
 */
export class BatchInternalApi extends runtime.BaseAPI {

    /**
     * Fetches batches
     */
    async findBatchesRaw(requestParameters: FindBatchesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiBatchPage>> {
        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page','Required parameter requestParameters.page was null or undefined when calling findBatches.');
        }

        if (requestParameters.size === null || requestParameters.size === undefined) {
            throw new runtime.RequiredError('size','Required parameter requestParameters.size was null or undefined when calling findBatches.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/batches`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiBatchPageFromJSON(jsonValue));
    }

    /**
     * Fetches batches
     */
    async findBatches(requestParameters: FindBatchesRequest, initOverrides?: RequestInit): Promise<InternalApiBatchPage> {
        const response = await this.findBatchesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches data upload status history
     */
    async findStatusHistoryRaw(requestParameters: FindStatusHistoryRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiDataUploadStatusHistoryRecord>>> {
        if (requestParameters.uploadId === null || requestParameters.uploadId === undefined) {
            throw new runtime.RequiredError('uploadId','Required parameter requestParameters.uploadId was null or undefined when calling findStatusHistory.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/data-uploads/{uploadId}/status-history`.replace(`{${"uploadId"}}`, encodeURIComponent(String(requestParameters.uploadId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiDataUploadStatusHistoryRecordFromJSON));
    }

    /**
     * Fetches data upload status history
     */
    async findStatusHistory(requestParameters: FindStatusHistoryRequest, initOverrides?: RequestInit): Promise<Array<InternalApiDataUploadStatusHistoryRecord>> {
        const response = await this.findStatusHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upload data from a CSV file
     */
    async uploadBatchRaw(requestParameters: UploadBatchRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiBatch>> {
        if (requestParameters.type === null || requestParameters.type === undefined) {
            throw new runtime.RequiredError('type','Required parameter requestParameters.type was null or undefined when calling uploadBatch.');
        }

        if (requestParameters.file === null || requestParameters.file === undefined) {
            throw new runtime.RequiredError('file','Required parameter requestParameters.file was null or undefined when calling uploadBatch.');
        }

        const queryParameters: any = {};

        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }

        if (requestParameters.delimiter !== undefined) {
            queryParameters['delimiter'] = requestParameters.delimiter;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file as any);
        }

        const response = await this.request({
            path: `/v1/batches`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiBatchFromJSON(jsonValue));
    }

    /**
     * Upload data from a CSV file
     */
    async uploadBatch(requestParameters: UploadBatchRequest, initOverrides?: RequestInit): Promise<InternalApiBatch> {
        const response = await this.uploadBatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum UploadBatchTypeEnum {
    PERSON = 'PERSON',
    PERSON_RELATION = 'PERSON_RELATION',
    PERSON_SCHEMA = 'PERSON_SCHEMA',
    TRANSACTION = 'TRANSACTION',
    TRANSACTION_UPDATE = 'TRANSACTION_UPDATE',
    TRANSACTION_SCHEMA = 'TRANSACTION_SCHEMA',
    SCENARIO = 'SCENARIO',
    RISKRULE = 'RISKRULE',
    CLEARANCE_RULE = 'CLEARANCE_RULE',
    QUERY_TEMPLATE = 'QUERY_TEMPLATE',
    CUSTOM_LIST_RECORD = 'CUSTOM_LIST_RECORD',
    CUSTOM_LIST_RECORD_RELATION = 'CUSTOM_LIST_RECORD_RELATION',
    TRANSACTION_DELETE_LIST = 'TRANSACTION_DELETE_LIST',
    PERSON_DELETE_LIST = 'PERSON_DELETE_LIST',
    PERSON_STATUS = 'PERSON_STATUS',
    CUSTOM_LIST_RECORD_ARCHIVE_LIST = 'CUSTOM_LIST_RECORD_ARCHIVE_LIST'
}
/**
    * @export
    * @enum {string}
    */
export enum UploadBatchDelimiterEnum {
    COMMA = 'COMMA',
    SEMICOLON = 'SEMICOLON',
    PIPE = 'PIPE',
    TAB = 'TAB'
}
